import { render, staticRenderFns } from "./MinusIcon.vue?vue&type=template&id=d451f94c&scoped=true"
import script from "./MinusIcon.vue?vue&type=script&lang=js"
export * from "./MinusIcon.vue?vue&type=script&lang=js"
import style0 from "./MinusIcon.vue?vue&type=style&index=0&id=d451f94c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d451f94c",
  null
  
)

export default component.exports